import React, {PropTypes as T} from 'react';

const ChevronRightIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Chevron Right Icon"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__chevronright ${className}`}>
    <path d="M144.9 506.1l-32.1-32.2 218.5-218.5L110 34.2 142.1 2l253.4 253.4z" />
  </svg>
);

ChevronRightIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  ChevronRightIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_chevron_right.js